'use client';

import { useCallback, useMemo, useState } from 'react';

type TurnstileActivationProps = {
  onChangeCapture?: () => void;
  onFocusCapture?: () => void;
  onPointerDownCapture?: () => void;
};

function waitForNextRender() {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, 0);
  });
}

export function useTurnstileActivation(enabled: boolean) {
  const [isActivated, setIsActivated] = useState(false);

  const activateTurnstile = useCallback(async () => {
    if (!enabled || isActivated) {
      return;
    }

    setIsActivated(true);
    await waitForNextRender();
  }, [enabled, isActivated]);

  const turnstileActivationProps = useMemo<TurnstileActivationProps>(() => {
    if (!enabled || isActivated) {
      return {};
    }

    return {
      onChangeCapture: () => {
        void activateTurnstile();
      },
      onFocusCapture: () => {
        void activateTurnstile();
      },
      onPointerDownCapture: () => {
        void activateTurnstile();
      },
    };
  }, [activateTurnstile, enabled, isActivated]);

  return {
    activateTurnstile,
    isTurnstileActivated: !enabled || isActivated,
    turnstileActivationProps,
  };
}
